<template>
    <div class="gz-page-subtitle">
        <span>{{ title }}</span>
    </div>
</template>

<script>
export default {
    name: 'PageSubtitle',

    props: {
        title: {
            type: String
        }
    }
}
</script>